(ns app.survey.login.email-or-sms.state)

(def states
  [::none
   ::auth-ok
   ::checking-email
   ::no-phone-registered
   ::verify-phone-number
   ::sent-email-token
   ::sent-sms-token
   ::logged-out
   ::logging-out])
